import api from "./api";


export const get_user_data = async(data) => {
    const response = await api.post('/profile/get_user',data);
    return response.data;
}

export const update_user = async(data) => {
    const response = await api.put('/profile/update_user',data);
    return response.data;
}

export const get_orders = async(data) => {
    const response = await api.post('/profile/get_order',data);
    return response.data;
}

export const get_address =  async (data) => {
    const response = await api.get(`/profile/address/${data}`);
    return response.data;
}

export const create_address = async(data) => {
    let user_data = JSON.parse(sessionStorage.getItem("user"))
    data["user_id"] = user_data.id
    const response = await api.post('/profile/create_address',data);
    return response.data;
}

export const get_specific_address = async (id) => {
    const response = await api.get(`/profile/get_address/${id}`)
    return response.data;
}

export const edit_address = async(data) => {
    let user_data = JSON.parse(sessionStorage.getItem("user"))
    data["user_id"] = user_data.id
    const response = await api.put('/profile/edit_address',data);
    return response.data;
}


export const delete_address = async (data) => {
    const response = await api.delete(`/profile/delete/address/${data}`)
    return response.data;
}

